import { useState, FormEvent } from 'react';
import { siteInfo } from '@/mocks/photography';

export default function CTASection() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('https://readdy.ai/api/form/d9tgu8tca23r0tr1aiu0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries()).filter(([k]) => k !== 'website_alt').map(([k, v]) => [k, v as string])
        ).toString(),
      });
      const responseText = await res.text();
      let parsed: any = { code: '', message: '', meta: { message: '', detail: '' } };
      try { parsed = JSON.parse(responseText); } catch { /* */ }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';

      if (res.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        form.reset();
      } else {
        setError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setError('网络错误，请检查网络后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            预约拍摄咨询
          </h2>
          <p className="text-foreground-600 text-sm max-w-md mx-auto">
            留下您的需求，我们的顾问将在24小时内与您联系
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-5">
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-phone-line text-primary-500"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950">电话咨询</p>
                <p className="text-sm text-foreground-600">{siteInfo.phone}</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-mail-line text-primary-500"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950">电子邮箱</p>
                <p className="text-sm text-foreground-600">{siteInfo.email}</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-line text-primary-500"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950">工作室地址</p>
                <p className="text-sm text-foreground-600">{siteInfo.address}</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-time-line text-primary-500"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950">营业时间</p>
                <p className="text-sm text-foreground-600">{siteInfo.workingHours}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            {submitted ? (
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-8 text-center">
                <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-primary-500 text-2xl"></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-950 mb-2">提交成功！</h3>
                <p className="text-sm text-foreground-600">感谢您的咨询，我们将在24小时内与您联系。</p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7"
                data-readdy-form
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm text-foreground-700 mb-1.5">姓名 *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 border border-background-200/70 rounded-lg text-sm bg-background-50 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-foreground-700 mb-1.5">手机号 *</label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      className="w-full px-4 py-2.5 border border-background-200/70 rounded-lg text-sm bg-background-50 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="您的手机号"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-sm text-foreground-700 mb-1.5">电子邮箱</label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-2.5 border border-background-200/70 rounded-lg text-sm bg-background-50 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm text-foreground-700 mb-1.5">意向拍摄风格</label>
                  <select
                    name="style"
                    className="w-full px-4 py-2.5 border border-background-200/70 rounded-lg text-sm bg-background-50 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
                  >
                    <option value="">请选择拍摄风格</option>
                    <option value="personal">个人写真</option>
                    <option value="couple">情侣写真</option>
                    <option value="artistic">艺术写真</option>
                    <option value="family">亲子写真</option>
                    <option value="other">其他风格</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label className="block text-sm text-foreground-700 mb-1.5">留言（选填）</label>
                  <textarea
                    name="message"
                    rows={3}
                    maxLength={500}
                    className="w-full px-4 py-2.5 border border-background-200/70 rounded-lg text-sm bg-background-50 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请描述您的拍摄需求和期望..."
                  ></textarea>
                </div>

                <div className="honeypot-wrapper" aria-hidden="true">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                    aria-hidden="true"
                    className="honeypot-field"
                  />
                </div>

                {error && (
                  <p className="text-sm text-red-500 mb-3">{error}</p>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer whitespace-nowrap"
                >
                  {loading ? '提交中...' : '提交预约咨询'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}